import React from 'react'
import { Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import { useChangePasswordMutation } from '../../../redux/services/ProfileService'
import { convertToFormData, sweetAlert } from '../../../utils'
import { responseError } from '../../../helpers/responseHandler'
import LoadingButtonWithForm from '../../../components/LoadingButtonWithForm'

const ChangePassword = ({ isEdit }) => {
    let {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: { errors },
    } = useForm()

    const [editRequest, { isLoading: editLoading }] = useChangePasswordMutation()

    const onSubmit = async (data) => {
        const newForm = convertToFormData(data)
        await editRequest(newForm).unwrap()
            .then((res) => {
                if (res?.status) {
                    sweetAlert(res?.message, 'success')
                    reset()
                }
            })
            .catch((err) => {
                responseError(err)
            })
    }
    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="">
                        <div className="p-5">
                            <div className="mb-4 main-content-label">
                                CHANGE PASSWORD
                            </div>
                            <Form onSubmit={handleSubmit(onSubmit)} className="form-horizontal" id='password-status'>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-2">
                                            <label className="form-label">Current Password</label>
                                        </div>
                                        <div className="col-md-10">
                                            <Controller
                                                name="current_password"
                                                control={control}
                                                defaultValue={isEdit?.current_password || ''}
                                                rules={{
                                                    required: true
                                                }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        {...field}
                                                        type="password"
                                                        placeholder="Enter Current Password"
                                                        isInvalid={errors.current_password}
                                                    />
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group ">
                                    <div className="row">
                                        <div className="col-md-2">
                                            <label className="form-label">New Password</label>
                                        </div>
                                        <div className="col-md-10">
                                            <Controller
                                                name="password"
                                                control={control}
                                                defaultValue={isEdit?.password || ''}
                                                rules={{
                                                    required: true,
                                                    validate: (value) => value !== watch('current_password') || 'The new password must be different from the current password'
                                                }}
                                                render={({ field }) => (
                                                    <>
                                                        <Form.Control
                                                            {...field}
                                                            type="password"
                                                            placeholder="Enter New Password"
                                                            isInvalid={errors.password}
                                                        />
                                                        {errors?.password && <Form.Control.Feedback type="invalid">{errors.password.message}</Form.Control.Feedback>}
                                                    </>

                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group ">
                                    <div className="row">
                                        <div className="col-md-2">
                                            <label className="form-label">Confirm Password</label>
                                        </div>
                                        <div className="col-md-10">
                                            <Controller
                                                name="confirm_password"
                                                control={control}
                                                defaultValue={isEdit?.confirm_password || ''}
                                                rules={{
                                                    required: true,
                                                    validate: (value) => value === watch('password') || 'The passwords do not match'
                                                }}
                                                render={({ field }) => (
                                                    <>
                                                        <Form.Control
                                                            {...field}
                                                            type="password"
                                                            placeholder="Enter Confirm Password"
                                                            isInvalid={errors.confirm_password}
                                                        />
                                                        {errors?.confirm_password && <Form.Control.Feedback type="invalid">{errors.confirm_password.message}</Form.Control.Feedback>}
                                                    </>

                                                )}
                                            />

                                        </div>
                                    </div>
                                </div>

                            </Form>

                        </div>
                        <div className="card-footer d-flex justify-content-end">
                            <button
                                type="button"
                                className="btn ripple btn-light w-sm me-2"
                            >
                                Cancel
                            </button>
                            <LoadingButtonWithForm
                                isLoading={editLoading}
                                name="Save"
                                form="password-status"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ChangePassword